const ERROR = {
  'User does not exist': '無此帳號，請先註冊',
  'You in the exam': '您已報名棋力檢定，可直接開始檢定',
  'Invalid password': '密碼錯誤',
  'Error Email': '您的證件號碼或電子信箱有誤',
  'Not found the user': '您的證件號碼或電子信箱有誤',
  'The email has used': '您的電子信箱已被使用',
  'the game is over': '檢定-下棋已結束，請重新整理或重新進入對局',
  'the tsume is over': '檢定-做題已結束，請重新整理或重新進入檢定',
  'The identification has signed': '該證件號碼已註冊',
  'Error verification code': '驗證碼錯誤',
  'previous exam item is not over':
    '前一個檢定項目尚未完成，請重新整理或重新進入檢定',
};

export default ERROR;
